type ValidationResult<T> =
  | { isValid: true; error: null }
  | { isValid: false; error: T };

export enum CauseOfDeathNameError {
  Required,
  Duplicated,
}

export function validateCauseOfDeathName<
  T extends { id: number; name: string }
>(
  name: string,
  causeOfDeaths: T[],
  selectedCauseOfDeathId: number | null
): ValidationResult<CauseOfDeathNameError> {
  if (!name.trim()) {
    return { isValid: false, error: CauseOfDeathNameError.Required };
  }

  const isDuplicate = causeOfDeaths.some(
    (item) =>
      item.name.trim().toLowerCase() === name.trim().toLowerCase() &&
      item.id !== selectedCauseOfDeathId
  );

  if (isDuplicate) {
    return { isValid: false, error: CauseOfDeathNameError.Duplicated };
  }

  return { isValid: true, error: null };
}
